module.exports = __webpack_public_path__ + "2ba25ff7e8da6eb825be06535d612c5b.jpg";